








































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { Getter } from "vuex-class";
import {
  EntityTypeDto,
  EntityGroupDto,
  LanguageDto,
  EntityDto
} from "@/server/app.dtos";
import ConfigsService from "@/services/api/configs.service";
import EntitiesService from "@/services/api/entities.service";
import { EditEntityCommand } from "@/server/app.commands";
import { NotificationServiceBus } from "@/services/bus/notifications.service";

@Component
export default class EntityEditPage extends Vue {
  @Prop() entity!: EntityDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  instance!: EditEntityCommand;
  entitiesService: EntitiesService = new EntitiesService();

  configsService: ConfigsService = new ConfigsService();
  entityTypes: EntityTypeDto[] = [];
  entityGroups: EntityGroupDto[] | null = null;
  tabs: string[] = ["Dados Gerais", "Atributos"];
  currentTab: string = "general";
  isLoading: boolean = false;
  isValid: boolean = false;
  currentType: number = 0;
  currentGroup: number = 0;

  start: Date = new Date();

  async created() {
    this.instance = new EditEntityCommand();
    this.instance.init(this.entity);
    await this.LoadRelatedData();
  }
  async LoadRelatedData() {
    const query: string = "IdLanguage=" + this.currentLanguage.idLanguage;

    await this.configsService.Load("api/EntityTypes", query).then(result => {
      this.entityTypes = result;
      if (this.instance) {
        this.currentType = this.instance.idEntityType || 1;
      }
    });

    await this.configsService.Load("api/EntityGroups", query).then(result => {
      this.entityGroups = result;
      if (this.instance || this.entityGroups) {
        this.currentGroup = this.instance.idEntityGroup || 1;
      }
    });
  }

  @Watch("currentType")
  onCurrentTypeChanged(): void {
    this.instance.idEntityType = this.currentType;
  }

  @Watch("currentGroup")
  onCurrentGroupChanged(): void {
    this.instance.idEntityGroup = this.currentGroup;
  }

  async onEditUser() {
    if (this.isLoading) return;
    this.isLoading = true;

    await this.entitiesService
      .Edit(this.instance)
      .then((id: number) => {
        NotificationServiceBus.showSuccessMessage(
          "Sucesso",
          "Operação efetuada com sucessso"
        );
        this.$router.push(`/entity/${id}/dashboard`);
      })
      .catch((error: any) => NotificationServiceBus.showError(error))
      .finally(() => (this.isLoading = false));
  }
}
